import api from "./api";
import publicApi from "./checkout/publicApi";

export const userAuth = async () => {
  const res = await api.get("user/auth/");
  return res.data;
};

export const userExists = async (email: string) => {
  const res = await publicApi.get("user/exists", { params: { email } });
  console.log(res.data);
  return res.data;
};

export const registerUser = async (data: {
  email: string;
  password: string;
  full_name: string;
  phone_number: string;
  address: string;
  promotion_opt_in: boolean;
  emergency_contact_phone_number: string;
  emergency_contact_name: string;
}) => {
  const res = await publicApi.post("user/", { ...data });
  return res.data;
};

export const validToken = async (token: string) => {
  const res = await publicApi.get("user/auth", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const sendResetEmail = async (email: string) => {
  const res = await publicApi.post(
    "user/token-mail/",
    { email: email },
    {
      params: {
        email: email,
      },
    }
  );

  return res.data;
};

export const changePassword = async (data: {
  token: string;
  password: string;
}) => {
  const res = await publicApi.put(
    "user/edit/",
    {
      password: data.password,
    },
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    }
  );
  return res.data;
};
